import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const team = [
    { id: 1, name: 'Ingrid Larsen', role: 'Administrerende direktør', bio: 'Ingrid har over 15 års erfaring innen spillindustrien og leder vår visjon med lidenskap. Hun har en mastergrad i næringsøkonomi og brenner for å skape de beste spillopplevelsene.' },
    { id: 2, name: 'Mette Solvang', role: 'Markedssjef', bio: 'Mette er ansvarlig for våre markedsstrategier og har en imponerende bakgrunn innen digital markedsføring. Hun sørger for at HeroPixelLab når ut til spillere over hele verden.' },
    { id: 3, name: 'Henrik Dahl', role: 'Teknisk direktør', bio: 'Henrik leder vår tekniske avdeling med fokus på innovasjon og kvalitet. Han har utviklet vår plattform og sikrer en sikker og smidig handleopplevelse for alle kunder.' },
    { id: 4, name: 'Sofie Berg', role: 'Kundeserviceansvarlig', bio: 'Sofie har et brennende ønske om å hjelpe. Hun koordinerer vårt kundestøtteteam og sørger for at alle henvendelser blir løst raskt og profesjonelt.' },
    { id: 5, name: 'Lars Jacobsen', role: 'Produktsjef', bio: 'Lars har et skarpt øye for kvalitet og er ansvarlig for å velge ut de beste spillene i vår katalog. Hans ekspertise sikrer at vi alltid har noe interessant for enhver spiller.' }
  ];

  return (
    <div className="container">
      <Helmet>
        <title>Om Oss - HeroPixelLab</title>
        <meta name="description" content="Lær mer om HeroPixelLab - vårt team, vår visjon og vår lidenskap for spill." />
        <link href="https://heropixellab.com/about/" rel="canonical"/>
      </Helmet>

      <div style={{ padding: '60px 0' }}>
        <h1 style={{ fontSize: '40px', color: '#00e5ff', marginBottom: '30px', textAlign: 'center' }}>Vår Historie</h1>
        <p className="about-text">
          HeroPixelLab ble grunnlagt i 2015 med en visjon om å skape den beste nettbutikken for online dataspill. Vi startet med tre personer og en stor drøm. Gjennom årene har vi vokst betydelig og har nådd tusenvis av fornøyde kunder over hele verden. Vår suksess er bygget på kvalitetsprodukter, ærlig prising og enestående kundeservice.
        </p>
        <p className="about-text">
          Vår reise har vært fylt med utfordringer og triumfer. Vi har lært, utviklet oss og forbedret oss kontinuerlig. I dag er vi stolte over å være en pålitelig aktør i spillmarkedet med fokus på innovasjon og integritet. Vi fortsetter å utforske nye muligheter og utvider stadig vår portefølje av spill.
        </p>

        <h2 style={{ fontSize: '32px', color: '#00e5ff', marginBottom: '30px', textAlign: 'center' }}>Vårt Team</h2>
        <div className="team-grid">
          {team.map((member) => (
            <div className="team-card" key={member.id}>
              <img src={`/images/team_${member.id}.jpg`} width="400" alt={`Team medlem ${member.id}`} />
              <h3>{member.name}</h3>
              <p className="position">{member.role}</p>
              <p>{member.bio}</p>
            </div>
          ))}
        </div>

        <div className="page-number">Side 2</div>
      </div>
    </div>
  );
}

export default About;